export const resourceTypeOptions = [
    { value: "earning-group", label: "by-earning-group" },
    { value: "hour-type", label: "by-hour-type" },
    { value: "groupings", label: "by-groupings" },
    { value: "pay-code", label: "pay-codes" },
];

export const resourceSelectConfig = {
    "earning-group": {
        label: "earning-groups",
        requiredMessage: "required-earning-group",
        placeholder: "earning-groups",
        resourcePath: "/earning-group",
        field: "earningGroups",
    },
    groupings: {
        label: "groupings-with-pay-codes",
        requiredMessage: "groupings-required",
        placeholder: "groupings-with-pay-codes",
        resourcePath: "/grouping?resource=pay-code",
        field: "groupings",
    },
    "pay-code": {
        label: "pay-codes",
        requiredMessage: "required-pay-codes",
        placeholder: "pay-codes",
        resourcePath: "/pay-code",
        field: "payCodes",
    },
    "hour-type": {
        field: "hourTypes",
    },
};

export const manageAbilityOptions = [
    { value: "role", label: "by-roles" },
];

export const getAllocatedResources = (record) => {
    const field = resourceSelectConfig[record?.type]?.field;
    const items = field ? record?.[field] : null;
    if (Array.isArray(items) && items.length > 0) {
        return items;
    }
    return Array.isArray(record?.resourceIds) ? record.resourceIds : [];
};
